import React from 'react';

import style from './banner.module.scss';

export const Banner = () => {
    return (
        <div className={style.banner}>
            <div className={style.bannerTextContainer}>
                <p className={style.bannerText}>A Leading provider of O-Rings,Oil Seals,and Related Sealing Products</p>
            </div>
        </div>
    );
};
